import React, { useEffect, useState, useCallback } from 'react';
import { useAxios } from '../../Helpers/AxiosHelper';
import {
    Column,
    DataTable,
    InputSwitch
} from '../../Common/Imports';
import { ApiResponse, AspNetRolesMenuItemsPermissions_EXT, Items_EXT, ItemsPermissions_EXT } from '../../Models/Classes';
interface PermissionsListProps {
    IDAspNetRole: string;
    IDItem: string;
}

export const PermissionsList: React.FC<PermissionsListProps> = ({ IDAspNetRole, IDItem }) => {
    const [PermissionListData, SetPermissionListData] = useState<ItemsPermissions_EXT[]>([]);
    const AxiosHelper = useAxios();

    const GetData = useCallback(async () => {
        try {
            const resp = await AxiosHelper.get<ApiResponse<ItemsPermissions_EXT[]>>(`Auth/GetPermissions/${IDAspNetRole}/${IDItem}`);
            if (resp.data.code === 0) {
                SetPermissionListData(resp.data.data)
            } else {
                return [];
            }
        } catch {
            return [];
        }
    }, [AxiosHelper, IDAspNetRole, IDItem]);

    useEffect(() => {
        GetData();
    }, [GetData]);

    const PermissionTemplate = (data: AspNetRolesMenuItemsPermissions_EXT[] | undefined, IDItem: string, IDPermission: number) => {
        let _D = false;
        if (data && data.length > 0) {
            _D = true
        }
        return <InputSwitch checked={_D} onChange={() => { UpdatePermission(data, IDAspNetRole, IDItem, IDPermission) }} />;
    }

    const UpdatePermission = async (ActiveRoles: AspNetRolesMenuItemsPermissions_EXT[] | undefined, IDAspNetRole: string | undefined, IDItem: string, IDPermission: number) => {
        if (ActiveRoles && ActiveRoles?.length > 0) {
            try {
                const resp = await AxiosHelper.get<ApiResponse<Items_EXT[]>>(`Auth/RemovePermission/${IDAspNetRole}/${IDItem}/${IDPermission}`);
                if (resp.data.code === 0) {
                    GetData();
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else {
            try {
                const resp = await AxiosHelper.get<ApiResponse<Items_EXT[]>>(`Auth/AddPermission/${IDAspNetRole}/${IDItem}/${IDPermission}`);
                if (resp.data.code === 0) {
                    GetData();
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    }

    return (
        <div className="p-3">
            <DataTable
                paginator
                rows={10}
                rowsPerPageOptions={[10, 20, 50]}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                value={PermissionListData}
                selectionMode="single"
                rowClassName={rowData => {
                    if (rowData.aspNetRolesMenuItemsPermissions && rowData.aspNetRolesMenuItemsPermissions.length > 0) {
                        return "rowGreen";
                    } else {
                        return "rowRed";
                    }
                }}>
                <Column
                    field="permission.idPermission"
                    bodyClassName="table-cell-nowrap" />
                <Column
                    field="permission.name"
                    bodyClassName="table-cell-nowrap" />
                <Column
                    field="permission.description"
                    bodyClassName="table-cell-nowrap" />
                <Column
                    field="name"
                    body={(e: ItemsPermissions_EXT) => { return PermissionTemplate(e.aspNetRolesMenuItemsPermissions, e.idItem, e.idPermission) }}
                    bodyClassName="table-cell-nowrap"
                    style={{ width: '5rem' }} />
            </DataTable>
        </div>
    );
};

export default PermissionsList;
